/**
 * @author    Odessa Team (odessateam@ab-soft.net)
 * @category  Ringcentral
 * @copyright Copyright (c) 2012-2019, RingCentral, Inc. (http://www.ringcentral.com)
 */
import RestClientWithStatusedResponse from "@signup/ajax/RestClientWithStatusedResponse";

/**
 * Implements basic Trust Site API default client.
 */
export default class TrustSiteApiDefaultBase
{
    /** REST API client */
    protected readonly rest: RestClientWithStatusedResponse;

    /**
     * Constructor.
     *
     * @param rest REST API client
     */
    constructor(rest: RestClientWithStatusedResponse)
    {
        this.rest = rest;
    }
}
